import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useStyleConfig, Flex, Box, Button, Text, Fade as Fade$1, Divider, Icon, HStack, InputGroup, Input, InputRightElement, Collapse, IconButton, InputLeftElement, Progress, RangeSlider, SliderMark, RangeSliderTrack, RangeSliderFilledTrack, Tooltip, RangeSliderThumb, Slider as Slider$1, SliderTrack, SliderFilledTrack, SliderThumb } from '@chakra-ui/react';
import { Fade } from '@chakra-ui/transition';
import { WarningIcon, InfoIcon, CheckIcon, ChevronLeftIcon, ChevronRightIcon, ChevronUpIcon, ChevronDownIcon, CloseIcon, Search2Icon } from '@chakra-ui/icons';
import { useAnimation, AnimatePresence, motion } from 'framer-motion';

var getPaddingBySize = function(size) {
    var padding = "4";
    switch(size){
        case "xs":
            padding = "2";
            break;
        case "sm":
            padding = "3";
            break;
        case "md":
            padding = "4";
            break;
        case "lg":
            padding = "6";
            break;
    }
    return padding;
};
var SnackbarConfig = {
    Snackbar: {
        baseStyle: function(options) {
            return {
                padding: getPaddingBySize(options.size),
                fontSize: options.size || "md",
                rounded: "lg",
                bgColor: "black.400",
                color: "white",
                boxShadow: "md",
                justifyContent: "space-between"
            };
        }
    }
};

var BannerConfig = {
    Banner: {
        baseStyle: function(options) {
            return {
                padding: options.size,
                fontSize: options.size || "md",
                bgColor: "white",
                color: "black.400",
                boxShadow: "md"
            };
        }
    }
};

var DialogConfig = {
    Dialog: {
        baseStyle: function(options) {
            return {
                padding: options.size,
                fontSize: options.size || "md",
                bgColor: "white",
                color: "black.400",
                boxShadow: "md"
            };
        }
    }
};

var SteperConfig = {
    Steper: {
        baseStyle: function(options) {
            return {
                fontSize: options.size || "sm",
                justifyContent: "space-between",
                colorScheme: "brand"
            };
        }
    },
    Step: {
        baseStyle: function(options) {
            return {
                fontSize: options.size || "sm",
                justifyContent: "space-between",
                colorScheme: "brand"
            };
        }
    }
};

var TabsConfig = {
    Tabs: {
        baseStyle: function(options) {
            return {
                fontSize: options.size || "sm",
                justifyContent: "space-between",
                colorScheme: "brand"
            };
        }
    },
    Tab: {
        baseStyle: function(options) {
            return {
                fontSize: options.size || "sm",
                justifyContent: "space-between",
                colorScheme: "brand"
            };
        }
    }
};

var PaginationConfig = {
    Pagination: {
        baseStyle: function(options) {
            return {
                fontSize: options.size || "sm",
                justifyContent: "center",
                colorScheme: "brand"
            };
        }
    }
};

var DropdownConfig = {
    Dropdown: {
        baseStyle: function(options) {
            return {
                fontSize: options.size || "sm",
                justifyContent: "space-between",
                colorScheme: "brand"
            };
        }
    },
    DropdownItem: {
        baseStyle: function(options) {
            return {
                fontSize: options.size || "sm",
                justifyContent: "space-between",
                colorScheme: "brand"
            };
        }
    }
};

var NavMenuConfig = {
    NavMenu: {
        baseStyle: function(options) {
            return {
                fontSize: options.size || "sm",
                justifyContent: "space-between",
                colorScheme: "brand"
            };
        }
    },
    NavMenuItem: {
        baseStyle: function(options) {
            return {
                fontSize: options.size || "sm",
                justifyContent: "space-between",
                colorScheme: "brand",
                rounded: "none",
                w: "full"
            };
        }
    }
};

var ParagraphConfig = {
    Paragraph: {
        baseStyle: {
            fontSize: "14",
            lineHeight: "taller"
        },
        sizes: {
            "14": {
                fontSize: "14",
                lineHeight: "taller"
            },
            "15": {
                fontSize: "15",
                lineHeight: "6"
            }
        }
    }
};

var BottomSheetConfig = {
    BottomSheet: {
        baseStyle: function(options) {
            return {
                fontSize: options.size || "sm",
                justifyContent: "space-between",
                colorScheme: "brand"
            };
        }
    }
};

var AppbarConfig = {
    Appbar: {
        baseStyle: function(options) {
            return {
                padding: options.size,
                fontSize: options.size || "md",
                bgColor: "white",
                color: "black.400",
                position: "sticky",
                top: 0,
                left: 0,
                w: "full",
                h: 14
            };
        }
    }
};

var ProgressBarConfig = {
    ProgressBar: {
        baseStyle: {
            colorScheme: "brand",
            variant: "default",
            size: "xs" // === '4px' || '0.25rem'
        }
    }
};

var NavbarConfig = {
    Navbar: {
        baseStyle: function(options) {
            return {
                fontSize: options.size || "md",
                justifyContent: "space-between",
                colorScheme: "brand",
                position: "fixed",
                zIndex: 999
            };
        }
    },
    Nav: {
        baseStyle: function(options) {
            return {
                fontSize: options.size || "md",
                justifyContent: "space-between",
                colorScheme: "brand"
            };
        }
    }
};

var SliderConfig = {
    Slider: {
        defaultProps: {
            colorScheme: "brand",
            variant: "single-value"
        },
        baseStyle: function(options) {
            return {
                colorScheme: options.colorScheme
            };
        }
    }
};

function _extends$b() {
    _extends$b = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends$b.apply(this, arguments);
}
function _objectWithoutProperties$b(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose$b(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose$b(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Snackbar = function(props) {
    var variant = props.variant, size = props.size, children = props.children, actionText = props.actionText, _colorScheme = props.colorScheme, colorScheme = _colorScheme === void 0 ? "brand" : _colorScheme, flexDirection = props.flexDirection, rest = _objectWithoutProperties$b(props, [
        "variant",
        "size",
        "children",
        "actionText",
        "colorScheme",
        "flexDirection"
    ]);
    var styles = useStyleConfig("Snackbar", {
        variant: variant,
        size: size
    });
    return /*#__PURE__*/ React.createElement(Flex, _extends$b({
        sx: styles
    }, rest), /*#__PURE__*/ React.createElement(Box, null, /*#__PURE__*/ React.createElement(Box, {
        pr: flexDirection === "column" ? "4" : "0",
        pb: flexDirection === "column" ? "4" : "0"
    }, children)), actionText && /*#__PURE__*/ React.createElement(Flex, {
        justifyContent: flexDirection === "column" ? "flex-end" : "inital"
    }, /*#__PURE__*/ React.createElement(Button, {
        variant: "link",
        size: size,
        colorScheme: colorScheme
    }, actionText)));
};

function _arrayLikeToArray$6(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles$4(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends$a() {
    _extends$a = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends$a.apply(this, arguments);
}
function _iterableToArrayLimit$4(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest$4() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectWithoutProperties$a(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose$a(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose$a(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray$4(arr, i) {
    return _arrayWithHoles$4(arr) || _iterableToArrayLimit$4(arr, i) || _unsupportedIterableToArray$6(arr, i) || _nonIterableRest$4();
}
function _unsupportedIterableToArray$6(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$6(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$6(o, minLen);
}
var EnumAs;
(function(EnumAs) {
    EnumAs["Warning"] = "warning";
    EnumAs["Info"] = "info";
    EnumAs["Danger"] = "danger";
    EnumAs["Success"] = "success";
})(EnumAs || (EnumAs = {}));
var Banner = function(props) {
    var title = props.title, visibleTime = props.visibleTime, variant = props.variant, size = props.size, buttonProps = props.buttonProps, as = props.as, rest = _objectWithoutProperties$a(props, [
        "title",
        "visibleTime",
        "variant",
        "size",
        "buttonProps",
        "as"
    ]);
    var ref = _slicedToArray$4(useState(true), 2), showBanner = ref[0], setShowBanner = ref[1];
    var styles = useStyleConfig("Banner", {
        variant: variant,
        size: size
    });
    useEffect(function() {
        if (!buttonProps) {
            setTimeout(function() {
                setShowBanner(false);
            }, visibleTime || 3000);
        }
    }, []);
    var getBackgroundColor = function() {
        if (as === "warning") return "#FFF6CC";
        if (as === "danger") return "#FDF5F5";
        if (as === "success") return "#DBF4EC";
        return "white";
    };
    var renderIcon = function() {
        if (as === "warning") return /*#__PURE__*/ React.createElement(WarningIcon, {
            mr: "4",
            color: "#997E00"
        });
        if (as === "info" || as === "danger") return /*#__PURE__*/ React.createElement(InfoIcon, {
            mr: "4",
            color: as === "danger" ? "#DD6766" : "#4A4A4A"
        });
        if (as === "success") return /*#__PURE__*/ React.createElement(CheckIcon, {
            mr: "4",
            color: "#2E7761"
        });
        return null;
    };
    var getVariantColor = function() {
        if (as === "info" || as === "success") return "#038767";
        if (as === "warning") return "#F49342";
        if (as === "danger") return "#D44140";
        return "#038767";
    };
    return /*#__PURE__*/ React.createElement(Fade, {
        in: showBanner
    }, /*#__PURE__*/ React.createElement(Flex, _extends$a({
        sx: styles,
        flexDirection: "column",
        alignItems: "initial"
    }, rest), /*#__PURE__*/ React.createElement(Box, {
        p: "4",
        backgroundColor: getBackgroundColor()
    }, /*#__PURE__*/ React.createElement(Flex, {
        justify: "space-between",
        alignItems: "start"
    }, renderIcon(), /*#__PURE__*/ React.createElement(Text, {
        fontSize: "md"
    }, title)), /*#__PURE__*/ React.createElement(Flex, {
        justify: "end",
        mt: "4"
    }, (buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.cancelButtonTitle) && /*#__PURE__*/ React.createElement(Button, {
        variant: "outline",
        outlineColor: getVariantColor(),
        onClick: function() {
            return setShowBanner(false);
        },
        mr: (buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.okButtonTitle) ? "3" : undefined
    }, /*#__PURE__*/ React.createElement(Text, {
        color: "green"
    }, buttonProps.cancelButtonTitle)), (buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.okButtonTitle) && /*#__PURE__*/ React.createElement(Button, {
        variant: "solid",
        colorScheme: "green",
        onClick: function() {
            return setShowBanner(false);
        }
    }, /*#__PURE__*/ React.createElement(Text, {
        color: "white"
    }, buttonProps.okButtonTitle))))));
};

function _extends$9() {
    _extends$9 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends$9.apply(this, arguments);
}
function _objectWithoutProperties$9(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose$9(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose$9(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Dialog = function(props) {
    var isOpen = props.isOpen, onClose = props.onClose, onOk = props.onOk, variant = props.variant, size = props.size, children = props.children, title = props.title, buttonProps = props.buttonProps, rest = _objectWithoutProperties$9(props, [
        "isOpen",
        "onClose",
        "onOk",
        "variant",
        "size",
        "children",
        "title",
        "buttonProps"
    ]);
    var styles = useStyleConfig("Dialog", {
        variant: variant,
        size: size
    });
    var isFullWidth = variant === "full-width-button";
    return /*#__PURE__*/ React.createElement(Fade$1, {
        in: isOpen
    }, /*#__PURE__*/ React.createElement(Flex, _extends$9({
        sx: styles,
        borderRadius: "2xl",
        flexDirection: "column",
        alignItems: "initial"
    }, rest), !!title && /*#__PURE__*/ React.createElement(Box, {
        p: "4",
        backgroundColor: "white",
        borderColor: "black.100",
        borderTopRadius: "2xl"
    }, /*#__PURE__*/ React.createElement(Text, {
        fontSize: "lg",
        fontWeight: "bold"
    }, title)), /*#__PURE__*/ React.createElement(Box, {
        p: "4",
        backgroundColor: "white"
    }, /*#__PURE__*/ React.createElement(Text, null, children)), /*#__PURE__*/ React.createElement(Box, {
        p: "4",
        backgroundColor: "white",
        borderBottomRadius: "2xl"
    }, /*#__PURE__*/ React.createElement(Flex, {
        flexDirection: isFullWidth ? "column" : "row",
        justifyContent: isFullWidth ? "flex-start" : "flex-end"
    }, /*#__PURE__*/ React.createElement(Button, {
        variant: "outline",
        outlineColor: "brand.500",
        color: "brand.500",
        mb: isFullWidth ? "2" : "0",
        mr: isFullWidth ? "0" : "2",
        onClick: onClose
    }, (buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.cancelButtonTitle) || "No"), /*#__PURE__*/ React.createElement(Button, {
        variant: "solid",
        color: "white",
        backgroundColor: "brand.500",
        onClick: onOk
    }, (buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.okButtonTitle) || "Yes")))));
};

function _extends$8() {
    _extends$8 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends$8.apply(this, arguments);
}
function _objectWithoutProperties$8(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose$8(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose$8(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Steper = function(props) {
    var variant = props.variant, _step = props.step, step = _step === void 0 ? 0 : _step, size = props.size, children = props.children, _colorScheme = props.colorScheme, colorScheme = _colorScheme === void 0 ? "brand" : _colorScheme, rest = _objectWithoutProperties$8(props, [
        "variant",
        "step",
        "size",
        "children",
        "colorScheme"
    ]);
    var isCurrent = function(index) {
        if (index === step) return true;
        return false;
    };
    var isPassed = function(index) {
        if (index < step) return true;
        return false;
    };
    var styles = useStyleConfig("Steper", {
        variant: variant,
        size: size
    });
    return /*#__PURE__*/ React.createElement(Flex, _extends$8({
        sx: styles
    }, rest), React.Children.map(children, function(child, index) {
        var mutatedIndex = index + 1;
        if (child) {
            return /*#__PURE__*/ React.createElement(React.Fragment, null, mutatedIndex > 1 && /*#__PURE__*/ React.createElement(Flex, {
                alignItems: "center",
                w: "full",
                h: "32px"
            }, /*#__PURE__*/ React.createElement(Divider, {
                h: "5px",
                w: "full",
                bgColor: isCurrent(mutatedIndex) || isPassed(mutatedIndex) ? "".concat(colorScheme, ".300") : "gray.300",
                rounded: "full"
            })), /*#__PURE__*/ React.cloneElement(child, {
                index: mutatedIndex,
                isActive: isCurrent(mutatedIndex),
                isPassed: isPassed(mutatedIndex),
                colorScheme: colorScheme
            }));
        }
        return null;
    }));
};
var Step = function(props) {
    var index = props.index, isActive = props.isActive, isPassed = props.isPassed, children = props.children, _colorScheme = props.colorScheme, colorScheme = _colorScheme === void 0 ? "brand" : _colorScheme, rest = _objectWithoutProperties$8(props, [
        "index",
        "isActive",
        "isPassed",
        "children",
        "colorScheme"
    ]);
    var styles = useStyleConfig("Step");
    return /*#__PURE__*/ React.createElement(Flex, _extends$8({
        sx: styles
    }, rest), /*#__PURE__*/ React.createElement(Flex, {
        flexDirection: "column",
        alignItems: "center",
        position: "relative"
    }, /*#__PURE__*/ React.createElement(Flex, {
        justifyContent: "center",
        alignItems: "center",
        h: "32px",
        w: "32px",
        boxShadow: "md",
        rounded: "full",
        borderStyle: "solid",
        borderWidth: "3px",
        borderColor: isActive ? "".concat(colorScheme, ".500") : "transparent",
        bgColor: isPassed ? "".concat(colorScheme, ".500") : "white"
    }, isPassed ? /*#__PURE__*/ React.createElement(CheckIcon, {
        color: "white"
    }) : /*#__PURE__*/ React.createElement(Text, {
        fontWeight: "bold"
    }, index)), /*#__PURE__*/ React.createElement(Box, {
        mt: "4",
        lineHeight: "shorter",
        textAlign: "center",
        w: "100px"
    }, children)));
};

function _extends$7() {
    _extends$7 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends$7.apply(this, arguments);
}
function _objectWithoutProperties$7(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose$7(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose$7(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Tabs = function(_param) {
    var variant = _param.variant, size = _param.size, children = _param.children, _colorScheme = _param.colorScheme, colorScheme = _colorScheme === void 0 ? "brand" : _colorScheme, _backgroundColor = _param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? "white" : _backgroundColor, _defaultIndex = _param.defaultIndex, defaultIndex = _defaultIndex === void 0 ? 0 : _defaultIndex, isDisabled = _param.isDisabled, onChange = _param.onChange, rest = _objectWithoutProperties$7(_param, [
        "variant",
        "size",
        "children",
        "colorScheme",
        "backgroundColor",
        "defaultIndex",
        "isDisabled",
        "onChange"
    ]);
    var styles = useStyleConfig("Tabs", {
        variant: variant,
        size: size
    });
    var isCurrent = function(i) {
        return i === defaultIndex;
    };
    return /*#__PURE__*/ React.createElement(Box, _extends$7({
        sx: styles
    }, rest), /*#__PURE__*/ React.createElement(Flex, {
        flexDirection: "column",
        alignItems: "center",
        position: "relative",
        _hover: {
            cursor: isDisabled ? "not-allowed" : "pointer"
        }
    }, /*#__PURE__*/ React.createElement(Flex, {
        justifyContent: "center",
        alignItems: "center",
        h: "full",
        w: "auto",
        boxShadow: "md"
    }, React.Children.map(children, function(child, i) {
        if (!child) return null;
        return /*#__PURE__*/ React.createElement(Flex, {
            alignItems: "center",
            w: "full",
            h: "full"
        }, /*#__PURE__*/ React.cloneElement(child, {
            isSelected: isCurrent(i),
            colorScheme: colorScheme,
            backgroundColor: backgroundColor,
            isDisabled: isDisabled,
            onChange: onChange
        }));
    }))));
};
var Tab = function(_param) {
    var children = _param.children, isSelected = _param.isSelected, _colorScheme = _param.colorScheme, colorScheme = _colorScheme === void 0 ? "brand" : _colorScheme, _backgroundColor = _param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? "white" : _backgroundColor, isDisabled = _param.isDisabled, icon = _param.icon, onChange = _param.onChange, index = _param.index, rest = _objectWithoutProperties$7(_param, [
        "children",
        "isSelected",
        "colorScheme",
        "backgroundColor",
        "isDisabled",
        "icon",
        "onChange",
        "index"
    ]);
    var styles = useStyleConfig("Tab");
    var getBgColor = function() {
        if (isDisabled) return "black.200";
        return backgroundColor ? "".concat(backgroundColor, ".500") : "white";
    };
    var getBorderBottomColor = function() {
        if (isDisabled) {
            return "black.300";
        } else if (backgroundColor === "white") {
            if (isSelected) return "".concat(colorScheme, ".500");
            else return "transparent";
        } else {
            if (isSelected) return "white";
            else return "".concat(backgroundColor, ".500");
        }
    };
    var getColor = function() {
        if (isDisabled) return "black.300";
        return backgroundColor === "white" ? "black" : "white";
    };
    var getIconColor = function() {
        if (isDisabled) return "black.300";
        if (backgroundColor !== "white") return "white";
        return "".concat(colorScheme, ".500");
    };
    var handleClick = function() {
        if (isDisabled) return;
        if (onChange) {
            onChange(index);
        }
    };
    return /*#__PURE__*/ React.createElement(Flex, _extends$7({
        sx: styles
    }, rest), /*#__PURE__*/ React.createElement(Flex, _extends$7({
        justifyContent: "center",
        alignItems: icon ? undefined : "center",
        h: icon ? "70px" : "50px",
        w: "100px",
        borderStyle: "solid",
        bgColor: getBgColor(),
        borderBottomColor: getBorderBottomColor(),
        borderBottomWidth: "3px",
        color: getColor(),
        onClick: handleClick,
        tabIndex: index
    }, rest), icon ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Flex, {
        justifyContent: "space-around",
        flexDirection: "column",
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(Icon, {
        as: icon,
        color: getIconColor(),
        h: "20px",
        w: "20px",
        boxSize: "20px"
    }), /*#__PURE__*/ React.createElement(Text, null, children))) : children));
};

function _arrayLikeToArray$5(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles$1(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray$5(arr);
}
function _extends$6() {
    _extends$6 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends$6.apply(this, arguments);
}
function _iterableToArray$1(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread$1() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectWithoutProperties$6(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose$6(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose$6(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toConsumableArray$1(arr) {
    return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$5(arr) || _nonIterableSpread$1();
}
function _unsupportedIterableToArray$5(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$5(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$5(o, minLen);
}
var getCenter = function(current, range, rangeStep) {
    var bottom = range * rangeStep - range;
    var top = range * rangeStep;
    if (bottom < current && current <= top) {
        return true;
    }
    return false;
};
var Pagination = function(props) {
    var variant = props.variant, size = props.size, _range = props.range, range = _range === void 0 ? 5 : _range, _totalPage = props.totalPage, totalPage = _totalPage === void 0 ? 1 : _totalPage, _page = props.page, page = _page === void 0 ? 1 : _page, onChange = props.onChange, _colorScheme = props.colorScheme, colorScheme = _colorScheme === void 0 ? "brand" : _colorScheme, rest = _objectWithoutProperties$6(props, [
        "variant",
        "size",
        "range",
        "totalPage",
        "page",
        "onChange",
        "colorScheme"
    ]);
    var styles = useStyleConfig("Pagination", {
        variant: variant,
        size: size
    });
    var pages = useMemo(function() {
        return Array(totalPage).fill(0).map(function(_, key) {
            return key + 1;
        });
    }, [
        totalPage
    ]);
    var rangeStep = useMemo(function() {
        return Math.ceil(page / range);
    }, [
        page
    ]);
    var slicedPages = useMemo(function() {
        if (totalPage > range) {
            return _toConsumableArray$1(pages.filter(function(value) {
                return getCenter(value, range, rangeStep);
            }));
        }
        return pages;
    }, [
        totalPage,
        range,
        rangeStep,
        pages
    ]);
    var jumpToNextStep = function() {
        var currentIndex = slicedPages.indexOf(page);
        var countOfJump = range - currentIndex;
        goToPage(page + countOfJump);
    };
    var jumpToPrevStep = function() {
        var currentIndex = slicedPages.indexOf(page);
        var countOfJump = currentIndex + 1;
        goToPage(page - countOfJump);
    };
    var goToPage = function(target) {
        if (onChange) {
            onChange(target);
        }
    };
    var canGoToNextPage = useMemo(function() {
        if (page < totalPage) return true;
        return false;
    }, [
        page,
        totalPage
    ]);
    var canGoToPrevPage = useMemo(function() {
        if (page === 1) return false;
        return true;
    }, [
        page
    ]);
    var canGoToLastPage = useMemo(function() {
        if (slicedPages.includes(totalPage)) return false;
        return true;
    }, [
        page,
        totalPage
    ]);
    var canGoToFirstPage = useMemo(function() {
        if (slicedPages.includes(1)) return false;
        return true;
    }, [
        page
    ]);
    var goToNextPage = function() {
        goToPage(page + 1);
    };
    var goToPrevPage = function() {
        goToPage(page - 1);
    };
    var renderPageNumbers = function() {
        return slicedPages.map(function(pageNumber) {
            var isActive = pageNumber === page;
            return /*#__PURE__*/ React.createElement(Button, {
                key: "pageNumber-".concat(pageNumber),
                size: size,
                variant: isActive ? "solid" : "ghost",
                colorScheme: isActive ? colorScheme : "white",
                onClick: function() {
                    if (isActive) return null;
                    goToPage(pageNumber);
                }
            }, pageNumber);
        });
    };
    var renderLastPageNumbers = function() {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Button, {
            key: "pageNumber-jump-next",
            size: size,
            variant: "ghost",
            colorScheme: "black",
            onClick: jumpToNextStep
        }, "..."), /*#__PURE__*/ React.createElement(Button, {
            key: "pageNumber-last",
            size: size,
            variant: page === totalPage ? "solid" : "ghost",
            colorScheme: page === totalPage ? colorScheme : "white",
            onClick: function() {
                if (page === totalPage) return null;
                goToPage(totalPage);
            }
        }, totalPage));
    };
    var renderFirstPageNumbers = function() {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Button, {
            key: "pageNumber-first",
            size: size,
            variant: page === 1 ? "solid" : "ghost",
            colorScheme: page === 1 ? colorScheme : "white",
            onClick: function() {
                if (page === 1) return null;
                goToPage(1);
            }
        }, "1"), /*#__PURE__*/ React.createElement(Button, {
            key: "pageNumber-jump-prev",
            size: size,
            variant: "ghost",
            colorScheme: "black",
            onClick: jumpToPrevStep
        }, "..."));
    };
    return /*#__PURE__*/ React.createElement(HStack, _extends$6({
        spacing: "2",
        sx: styles
    }, rest), /*#__PURE__*/ React.createElement(Button, {
        onClick: goToPrevPage,
        size: size,
        disabled: !canGoToPrevPage,
        colorScheme: "black",
        variant: "ghost",
        p: "0"
    }, /*#__PURE__*/ React.createElement(ChevronLeftIcon, {
        boxSize: 8
    })), canGoToFirstPage && renderFirstPageNumbers(), renderPageNumbers(), canGoToLastPage && renderLastPageNumbers(), /*#__PURE__*/ React.createElement(Button, {
        onClick: goToNextPage,
        size: size,
        disabled: !canGoToNextPage,
        colorScheme: "black",
        variant: "ghost",
        p: "0"
    }, /*#__PURE__*/ React.createElement(ChevronRightIcon, {
        boxSize: 8
    })));
};

function useOutsideWrapper(ref, cb) {
    useEffect(function() {
        var handleClickOutside = function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                cb();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        ref
    ]);
}

var usePreviousState = function(value) {
    var previousValueRef = useRef();
    useEffect(function() {
        previousValueRef.current = value;
    }, [
        value
    ]);
    return previousValueRef.current;
};

function _arrayLikeToArray$4(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles$3(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends$5() {
    _extends$5 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends$5.apply(this, arguments);
}
function _iterableToArrayLimit$3(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest$3() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectWithoutProperties$5(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose$5(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose$5(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray$3(arr, i) {
    return _arrayWithHoles$3(arr) || _iterableToArrayLimit$3(arr, i) || _unsupportedIterableToArray$4(arr, i) || _nonIterableRest$3();
}
function _unsupportedIterableToArray$4(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$4(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$4(o, minLen);
}
var Dropdown = function(_param) {
    var children = _param.children, variant = _param.variant, _size = _param.size, size = _size === void 0 ? "md" : _size, _colorScheme = _param.colorScheme, colorScheme = _colorScheme === void 0 ? "brand" : _colorScheme, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? "Pilih salah satu" : _placeholder, _filterable = _param.filterable, filterable = _filterable === void 0 ? false : _filterable, rest = _objectWithoutProperties$5(_param, [
        "children",
        "variant",
        "size",
        "colorScheme",
        "placeholder",
        "filterable"
    ]);
    var styles = useStyleConfig("Dropdown", {
        variant: variant,
        size: size
    });
    var wrapperRef = useRef(null);
    var ref = _slicedToArray$3(useState(React.Children.toArray(children).map(function(child) {
        return child.props.children;
    })), 2), optionProps = ref[0], setOptionsProps = ref[1];
    var ref1 = _slicedToArray$3(useState(false), 2), isOpen = ref1[0], setOpen = ref1[1];
    var ref2 = _slicedToArray$3(useState(""), 2), value = ref2[0], setValue = ref2[1];
    useOutsideWrapper(wrapperRef, function() {
        setOpen(false);
    });
    var IconComponent = isOpen ? ChevronUpIcon : ChevronDownIcon;
    var onChange = function(event) {
        setValue(event.target.value);
    };
    var filterOptions = function(searchTerm) {
        var filteredOptions = optionProps.filter(function(opt) {
            return opt.toLowerCase().includes(searchTerm.toLowerCase());
        });
        setOptionsProps(filteredOptions);
    };
    useEffect(function() {
        if (filterable) {
            filterOptions(value);
        }
    }, [
        value
    ]);
    var onFocus = function() {
        setOpen(true);
        setValue("");
    };
    var onClick = function(data) {
        setOpen(false);
        setValue(data);
    };
    return /*#__PURE__*/ React.createElement(Box, {
        position: "relative"
    }, /*#__PURE__*/ React.createElement(InputGroup, {
        size: size,
        minW: "300px",
        w: "auto"
    }, /*#__PURE__*/ React.createElement(Input, {
        onFocus: onFocus,
        type: "text",
        colorScheme: colorScheme,
        size: size,
        placeholder: placeholder,
        value: value,
        onChange: filterable ? onChange : function() {
            return null;
        }
    }), /*#__PURE__*/ React.createElement(InputRightElement, {
        children: /*#__PURE__*/ React.createElement(IconComponent, {
            boxSize: "20px",
            color: "".concat(colorScheme, ".500")
        })
    })), /*#__PURE__*/ React.createElement(Box, {
        position: "absolute",
        zIndex: "popover"
    }, /*#__PURE__*/ React.createElement(Collapse, {
        in: isOpen,
        animateOpacity: true
    }, /*#__PURE__*/ React.createElement(Box, _extends$5({
        sx: styles
    }, rest, {
        minW: "300px",
        w: "auto",
        ref: wrapperRef
    }), /*#__PURE__*/ React.createElement(Flex, {
        flexDirection: "column",
        boxShadow: "md",
        rounded: "md",
        w: "auto"
    }, React.Children.map(children, function(child, index) {
        if (!child) return;
        var props = child.props;
        var isIncludes = props.children.toLowerCase().includes(value.toLowerCase());
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.cloneElement(child, {
            colorScheme: colorScheme,
            onClick: onClick,
            index: index,
            display: isIncludes ? "flex" : "none"
        }));
    }))))));
};
var DropdownItem = function(_param) {
    var children = _param.children, colorScheme = _param.colorScheme, leftIcon = _param.leftIcon, rightIcon = _param.rightIcon, onClick = _param.onClick, display = _param.display, rest = _objectWithoutProperties$5(_param, [
        "children",
        "colorScheme",
        "leftIcon",
        "rightIcon",
        "onClick",
        "display"
    ]);
    var styles = useStyleConfig("DropdownItem");
    var renderIcon = function(position, icon) {
        if (position === "left") {
            if (!leftIcon) return;
        } else if (position === "right") {
            if (!rightIcon) return;
        }
        return /*#__PURE__*/ React.createElement(Icon, {
            mr: position === "right" ? "3" : "0",
            ml: position === "left" ? "3" : "0",
            as: icon,
            _active: {
                cursor: "pointer",
                bg: "".concat(colorScheme, ".500"),
                color: "white"
            },
            h: "20px",
            w: "20px",
            boxSize: "1.25em"
        });
    };
    var getFlexDir = function() {
        return !!rightIcon || !!leftIcon ? "row" : "column";
    };
    var getAlignItems = function() {
        return !!rightIcon || !!leftIcon ? "center" : "flex-start";
    };
    var getJustifyContent = function() {
        if (!!rightIcon || !!leftIcon) {
            if (!!rightIcon && !!leftIcon) return "space-between";
            if (!!leftIcon && !rightIcon) return "flex-start";
            else return "space-between";
        } else {
            return "flex-start";
        }
    };
    return /*#__PURE__*/ React.createElement(Box, _extends$5({}, rest, {
        sx: styles,
        display: display,
        flexDir: getFlexDir(),
        alignItems: getAlignItems(),
        justifyContent: getJustifyContent(),
        onClick: function() {
            return onClick(children);
        },
        _hover: {
            cursor: "pointer",
            bg: "".concat(colorScheme, ".100"),
            color: "".concat(colorScheme, ".500")
        },
        _active: {
            cursor: "pointer",
            bg: "".concat(colorScheme, ".500"),
            color: "white"
        },
        gap: "2",
        minW: "165px",
        bg: "white"
    }), renderIcon("left", leftIcon), /*#__PURE__*/ React.createElement(Text, {
        as: "span",
        p: "3"
    }, children), renderIcon("right", rightIcon));
};

function _arrayLikeToArray$3(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles$2(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends$4() {
    _extends$4 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends$4.apply(this, arguments);
}
function _iterableToArrayLimit$2(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest$2() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectWithoutProperties$4(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose$4(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose$4(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray$2(arr, i) {
    return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i) || _unsupportedIterableToArray$3(arr, i) || _nonIterableRest$2();
}
function _unsupportedIterableToArray$3(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$3(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen);
}
var NavMenu = function(props) {
    var variant = props.variant, size = props.size, children = props.children, activeMenu = props.activeMenu, onChange = props.onChange, _colorScheme = props.colorScheme, colorScheme = _colorScheme === void 0 ? "brand" : _colorScheme, rest = _objectWithoutProperties$4(props, [
        "variant",
        "size",
        "children",
        "activeMenu",
        "onChange",
        "colorScheme"
    ]);
    var styles = useStyleConfig("NavMenu", {
        variant: variant,
        size: size
    });
    return /*#__PURE__*/ React.createElement(Box, _extends$4({
        sx: styles
    }, rest), React.Children.map(children, function(child) {
        if (child) {
            return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.cloneElement(child, {
                colorScheme: colorScheme,
                size: size,
                onChange: onChange,
                activeMenu: activeMenu
            }));
        }
        return null;
    }));
};
var NavMenuItem = function(props) {
    var label = props.label, icon = props.icon, activeMenu = props.activeMenu, _index = props.index, index = _index === void 0 ? "" : _index, onChange = props.onChange, size = props.size, children = props.children, _colorScheme = props.colorScheme, colorScheme = _colorScheme === void 0 ? "brand" : _colorScheme, rest = _objectWithoutProperties$4(props, [
        "label",
        "icon",
        "activeMenu",
        "index",
        "onChange",
        "size",
        "children",
        "colorScheme"
    ]);
    var ref = _slicedToArray$2(useState(false), 2), isOpen = ref[0], setIsOpen = ref[1];
    var styles = useStyleConfig("NavMenuItem", {
        colorScheme: colorScheme
    });
    var isActive = useMemo(function() {
        return activeMenu === index;
    }, [
        activeMenu,
        index
    ]);
    var hasChildren = useMemo(function() {
        return !!children;
    }, [
        children
    ]);
    var hasActiveChildren = useMemo(function() {
        var foundActiveChildren = false;
        if (hasChildren) {
            React.Children.map(children, function(child) {
                if (child.props.index === activeMenu) {
                    foundActiveChildren = true;
                }
            });
        }
        return foundActiveChildren;
    }, [
        children
    ]);
    useEffect(function() {
        if (hasActiveChildren) {
            setIsOpen(true);
        }
    }, [
        hasActiveChildren
    ]);
    var activeBorderColor = useMemo(function() {
        if (isActive) {
            return "white";
        }
        if (hasActiveChildren) {
            return "white";
        }
        return "transparent";
    }, [
        isActive,
        hasActiveChildren
    ]);
    var activeBgColor = useMemo(function() {
        if (hasActiveChildren) {
            return "".concat(colorScheme, ".600");
        }
        if (isActive && !hasChildren) {
            return "".concat(colorScheme, ".400");
        }
        return "".concat(colorScheme, ".500");
    }, [
        children,
        isActive
    ]);
    var hoverBgColor = useMemo(function() {
        if (hasActiveChildren) {
            return "".concat(colorScheme, ".600");
        }
        if (isActive && !hasChildren) {
            return "".concat(colorScheme, ".300");
        }
        return "".concat(colorScheme, ".400");
    }, [
        children,
        isActive
    ]);
    var clickHandler = function() {
        if (hasChildren) {
            setIsOpen(!isOpen);
        }
        if (onChange && !hasChildren) {
            onChange(index);
        }
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Button, _extends$4({
        sx: styles,
        colorScheme: colorScheme,
        onClick: clickHandler,
        boxShadow: "none",
        borderLeft: "5px",
        borderStyle: "solid",
        borderColor: activeBorderColor,
        bgColor: activeBgColor,
        _focus: {
            outline: "none"
        },
        _hover: {
            bgColor: hoverBgColor
        }
    }, rest), /*#__PURE__*/ React.createElement(Flex, {
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(Flex, {
        w: "30px",
        mr: "2",
        justifyContent: "center",
        alignItems: "center"
    }, icon && /*#__PURE__*/ React.cloneElement(icon)), /*#__PURE__*/ React.createElement(Text, null, label)), hasChildren && /*#__PURE__*/ React.createElement(ChevronRightIcon, {
        color: "white",
        boxSize: 6,
        transition: "transform .3s ease",
        transform: "rotate(".concat(isOpen ? "-90deg" : "90deg", ")")
    })), /*#__PURE__*/ React.createElement(Collapse, {
        in: isOpen,
        animateOpacity: true
    }, React.Children.map(children, function(child) {
        return /*#__PURE__*/ React.cloneElement(child, {
            colorScheme: colorScheme,
            size: size,
            onChange: onChange,
            activeMenu: activeMenu
        });
    })));
};
NavMenuItem.displayName = "NavMenuItem";

function _extends$3() {
    _extends$3 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends$3.apply(this, arguments);
}
function _objectWithoutProperties$3(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose$3(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose$3(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Paragraph = function(props) {
    var children = props.children, size = props.size, rest = _objectWithoutProperties$3(props, [
        "children",
        "size"
    ]);
    var styles = useStyleConfig("Paragraph", {
        size: size
    });
    return /*#__PURE__*/ React.createElement(Text, _extends$3({
        sx: styles
    }, rest), children);
};

function _extends$2() {
    _extends$2 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends$2.apply(this, arguments);
}
function _objectWithoutProperties$2(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose$2(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose$2(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var BottomSheet = function(_param) {
    var onDragEnd = function onDragEnd(_, info) {
        var shouldClose = info.velocity.y > 20 || info.velocity.y >= 0 && info.point.y > 45;
        if (shouldClose) {
            controls.start("hidden");
            handleClose();
        } else {
            controls.start("visible");
            handleOpen();
        }
    };
    var _isOpen = _param.isOpen, isOpen = _isOpen === void 0 ? false : _isOpen, onClose = _param.onClose, onOpen = _param.onOpen, children = _param.children, _variant = _param.variant, variant = _variant === void 0 ? "list" : _variant, _size = _param.size, size = _size === void 0 ? "md" : _size, colorScheme = _param.colorScheme, _title = _param.title, title = _title === void 0 ? "" : _title, rest = _objectWithoutProperties$2(_param, [
        "isOpen",
        "onClose",
        "onOpen",
        "children",
        "variant",
        "size",
        "colorScheme",
        "title"
    ]);
    var controls = useAnimation();
    var styles = useStyleConfig("BottomSheet", {
        variant: variant,
        size: size
    });
    var bottomSheetRef = useRef(null);
    var prevIsOpen = usePreviousState(isOpen);
    var handleClose = function() {
        if (onClose) onClose();
    };
    var handleOpen = function() {
        if (onOpen) onOpen();
    };
    useOutsideWrapper(bottomSheetRef, handleClose);
    useEffect(function() {
        if (prevIsOpen && !isOpen) {
            controls.start("hidden");
        } else if (!prevIsOpen && isOpen) {
            controls.start("visible");
        }
    }, [
        controls,
        isOpen
    ]);
    return /*#__PURE__*/ React.createElement(AnimatePresence, null, /*#__PURE__*/ React.createElement(motion.div, {
        drag: "y",
        onDragEnd: onDragEnd,
        animate: controls,
        transition: {
            type: "spring",
            damping: 40,
            stiffness: 400
        },
        variants: {
            visible: {
                y: 0
            },
            hidden: {
                y: 0
            }
        },
        dragConstraints: {
            top: 0
        },
        dragElastic: 0.2,
        style: {
            backgroundColor: "white",
            width: "100%",
            borderTopRightRadius: 10,
            borderTopLeftRadius: 10,
            position: "fixed",
            bottom: 0
        },
        ref: bottomSheetRef
    }, isOpen && /*#__PURE__*/ React.createElement(Box, _extends$2({
        sx: styles,
        width: "auto"
    }, rest), /*#__PURE__*/ React.createElement(Flex, {
        w: "auto",
        alignItems: "center",
        boxShadow: "md",
        p: "3",
        _hover: {
            cursor: "move"
        }
    }, /*#__PURE__*/ React.createElement(CloseIcon, {
        boxSize: "20px",
        mx: "2",
        _hover: {
            cursor: "pointer"
        },
        onClick: handleClose,
        color: colorScheme ? "".concat(colorScheme, ".500") : "black"
    }), /*#__PURE__*/ React.createElement(Text, {
        fontSize: size,
        color: colorScheme ? "".concat(colorScheme, ".500") : "black"
    }, title)), /*#__PURE__*/ React.createElement(Box, null, React.Children.map(children, function(child, index) {
        if (!child) return;
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.cloneElement(child, {
            colorScheme: colorScheme,
            index: index
        }));
    })))));
};

function _arrayLikeToArray$2(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles$1(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit$1(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest$1() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray$1(arr, i) {
    return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$2(arr, i) || _nonIterableRest$1();
}
function _unsupportedIterableToArray$2(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$2(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen);
}
var Appbar = function(param) {
    var size = param.size, _variant = param.variant, variant = _variant === void 0 ? "default" : _variant, _searchPlaceholder = param.searchPlaceholder, searchPlaceholder = _searchPlaceholder === void 0 ? "Search di sini" : _searchPlaceholder, leftIcon = param.leftIcon, rightIcon1 = param.rightIcon1, rightIcon2 = param.rightIcon2, _subtitle = param.subtitle, subtitle = _subtitle === void 0 ? "Subtitle" : _subtitle, _title = param.title, title = _title === void 0 ? "Appbar Title" : _title, leftIconHandler = param.leftIconHandler, rightIconHandler = param.rightIconHandler, rightIcon2Handler = param.rightIcon2Handler, searchHandler = param.searchHandler;
    var styles = useStyleConfig("Appbar", {
        variant: variant,
        size: size
    });
    var ref = _slicedToArray$1(useState(""), 2), search = ref[0], setSearch = ref[1];
    var handleChange = function(e) {
        setSearch(e.target.value);
        searchHandler === null || searchHandler === void 0 ? void 0 : searchHandler();
    };
    var renderAppbarContent = function() {
        if (variant === "search") {
            return /*#__PURE__*/ React.createElement(Box, {
                w: "full"
            }, /*#__PURE__*/ React.createElement(InputGroup, {
                size: "md"
            }, /*#__PURE__*/ React.createElement(InputLeftElement, {
                pointerEvents: "none",
                children: /*#__PURE__*/ React.createElement(Search2Icon, {
                    color: "grey.500",
                    fontSize: 12
                })
            }), /*#__PURE__*/ React.createElement(Input, {
                type: "text",
                variant: "filled",
                placeholder: searchPlaceholder,
                value: search,
                onChange: handleChange,
                backgroundColor: "whitesmoke",
                _placeholder: {
                    color: "grey.400"
                },
                color: "grey.800",
                name: "search-input"
            }), search && /*#__PURE__*/ React.createElement(InputRightElement, {
                children: /*#__PURE__*/ React.createElement(IconButton, {
                    variant: "solid",
                    backgroundColor: "grey.400",
                    _focus: {
                        outline: "none"
                    },
                    _hover: {
                        boxShadow: "none",
                        backgroundColor: "grey.500"
                    },
                    onClick: function() {
                        return setSearch("");
                    },
                    size: "xs",
                    "aria-label": "search",
                    rounded: "full",
                    boxShadow: "none",
                    icon: /*#__PURE__*/ React.createElement(CloseIcon, {
                        color: "white",
                        fontSize: 8
                    })
                })
            })));
        }
        return /*#__PURE__*/ React.createElement(Box, {
            lineHeight: 6,
            alignItems: "stretch",
            w: "70%"
        }, /*#__PURE__*/ React.createElement(Text, {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            as: "h1",
            fontSize: "xl",
            color: "black"
        }, title), subtitle && /*#__PURE__*/ React.createElement(Text, {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            as: "p",
            fontSize: "sm",
            color: "blackAlpha.500"
        }, subtitle));
    };
    return /*#__PURE__*/ React.createElement(Flex, {
        alignItems: "center",
        w: "100%",
        h: 14,
        zIndex: 999,
        px: leftIcon ? 0 : 4,
        sx: styles
    }, leftIcon && /*#__PURE__*/ React.createElement(Box, {
        w: "auto",
        p: 2
    }, /*#__PURE__*/ React.createElement(IconButton, {
        "aria-label": "",
        variant: "unstyled",
        fontSize: 24,
        icon: leftIcon,
        onClick: leftIconHandler,
        _focus: {
            outline: "none"
        }
    })), renderAppbarContent(), (rightIcon1 || rightIcon2) && variant !== "search" && /*#__PURE__*/ React.createElement(HStack, null, rightIcon1 && /*#__PURE__*/ React.createElement(IconButton, {
        "aria-label": "",
        icon: rightIcon1,
        variant: "unstyled",
        fontSize: 24,
        onClick: rightIconHandler,
        _focus: {
            outline: "none"
        }
    }), rightIcon2 && /*#__PURE__*/ React.createElement(IconButton, {
        "aria-label": "",
        icon: rightIcon2,
        variant: "unstyled",
        fontSize: 24,
        onClick: rightIcon2Handler,
        _focus: {
            outline: "none"
        }
    })));
};

function _arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray$1(arr);
}
function _extends$1() {
    _extends$1 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends$1.apply(this, arguments);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectWithoutProperties$1(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose$1(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}
var ProgressBar = function(props) {
    var _variant = props.variant, variant = _variant === void 0 ? "default" : _variant, _colorScheme = props.colorScheme, colorScheme = _colorScheme === void 0 ? "brand" : _colorScheme, steps = props.steps, currentStep = props.currentStep, showText = props.showText, rest = _objectWithoutProperties$1(props, [
        "variant",
        "colorScheme",
        "steps",
        "currentStep",
        "showText"
    ]);
    var renderProgress = function() {
        if (variant === "default") {
            var value = Math.round(currentStep / steps * 100);
            return /*#__PURE__*/ React.createElement(Progress, _extends$1({
                colorScheme: colorScheme,
                value: value,
                variant: variant,
                h: "4px",
                w: "full"
            }, rest));
        }
        return _toConsumableArray(Array(steps)).map(function(_, i) {
            return /*#__PURE__*/ React.createElement(Progress, _extends$1({
                key: i,
                colorScheme: i < currentStep ? colorScheme : "whiteAlpha",
                variant: variant,
                value: i < currentStep ? 100 : 0,
                rounded: "lg",
                h: "4px",
                w: "full"
            }, rest));
        });
    };
    return /*#__PURE__*/ React.createElement(Flex, {
        gap: 8,
        w: "full"
    }, showText && /*#__PURE__*/ React.createElement(Text, {
        color: "blackAlpha.500"
    }, steps, " step", steps <= 1 ? "" : "s"), /*#__PURE__*/ React.createElement(Flex, {
        flex: "1",
        alignItems: "center",
        gap: "2"
    }, renderProgress()));
};

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Navbar = function(_param) {
    var variant = _param.variant, _position = _param.position, position = _position === void 0 ? "top" : _position, size = _param.size, children = _param.children, _colorScheme = _param.colorScheme, colorScheme = _colorScheme === void 0 ? "brand" : _colorScheme, _defaultIndex = _param.defaultIndex, defaultIndex = _defaultIndex === void 0 ? 0 : _defaultIndex, onChange = _param.onChange, rest = _objectWithoutProperties(_param, [
        "variant",
        "position",
        "size",
        "children",
        "colorScheme",
        "defaultIndex",
        "onChange"
    ]);
    var styles = useStyleConfig("Navbar", {
        variant: variant,
        size: size
    });
    return /*#__PURE__*/ React.createElement(Box, _extends({
        backgroundColor: "white",
        width: "inherit",
        overflowY: "scroll",
        sx: styles,
        boxShadow: "md",
        _hover: {
            cursor: "pointer"
        }
    }, rest), /*#__PURE__*/ React.createElement(Flex, {
        justifyContent: "center",
        alignItems: "center"
    }, React.Children.map(children, function(child, i) {
        if (!child) return null;
        var isSelected = i === defaultIndex;
        var getBorderColor = function() {
            if (!isSelected) return "white";
            return "".concat(colorScheme, ".500");
        };
        var getColor = function() {
            if (!isSelected) return "grey.500";
            return "".concat(colorScheme, ".500");
        };
        return /*#__PURE__*/ React.createElement(Flex, {
            alignItems: "center",
            px: 2,
            borderStyle: "solid",
            bgColor: "white",
            borderBottomColor: position === "top" ? getBorderColor() : "transparent",
            borderTopColor: position === "bottom" ? getBorderColor() : "transparent",
            borderBottomWidth: position === "top" ? "3px" : "unset",
            borderTopWidth: position === "bottom" ? "3px" : "unset",
            color: getColor(),
            height: "56px",
            w: "full"
        }, /*#__PURE__*/ React.cloneElement(child, {
            isSelected: isSelected,
            colorScheme: colorScheme,
            onChange: onChange
        }));
    })));
};
var Nav = function(_param) {
    var children = _param.children, _colorScheme = _param.colorScheme, colorScheme = _colorScheme === void 0 ? "brand" : _colorScheme, icon = _param.icon, onChange = _param.onChange, index = _param.index, isSelected = _param.isSelected, twoLine = _param.twoLine, rest = _objectWithoutProperties(_param, [
        "children",
        "colorScheme",
        "icon",
        "onChange",
        "index",
        "isSelected",
        "twoLine"
    ]);
    var styles = useStyleConfig("Nav");
    var getIconColor = function() {
        if (!isSelected) return "grey.500";
        return "".concat(colorScheme, ".500");
    };
    var handleClick = function() {
        if (onChange) {
            onChange(index);
        }
    };
    return /*#__PURE__*/ React.createElement(Flex, _extends({
        justifyContent: "space-around",
        flexDirection: "column",
        alignItems: "center",
        lineHeight: "1",
        textAlign: "center",
        onClick: handleClick,
        tabIndex: index,
        sx: styles,
        flex: "1",
        gap: "1"
    }, rest), /*#__PURE__*/ React.createElement(Icon, {
        as: icon,
        color: getIconColor(),
        h: "24px",
        w: "24px",
        boxSize: "24px"
    }), /*#__PURE__*/ React.createElement(Text, {
        fontSize: "small",
        letterSpacing: twoLine ? "unset" : "tighter"
    }, children));
};

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var Slider = function(param) {
    var _variant = param.variant, variant = _variant === void 0 ? "single-value" : _variant, _colorScheme = param.colorScheme, colorScheme = _colorScheme === void 0 ? "brand" : _colorScheme, _showValue = param.showValue, showValue = _showValue === void 0 ? false : _showValue, _defaultValue = param.defaultValue, defaultValue = _defaultValue === void 0 ? variant === "single-value" ? 10 : [
        10,
        30
    ] : _defaultValue, _size = param.size, size = _size === void 0 ? "md" : _size, onChange = param.onChange, _min = param.min, min = _min === void 0 ? 0 : _min, _max = param.max, max = _max === void 0 ? 100 : _max, _step = param.step, step = _step === void 0 ? 10 : _step, choices = param.choices;
    var styles = useStyleConfig("Slider", {
        size: size,
        variant: variant
    });
    var ref = _slicedToArray(useState(defaultValue), 2), sliderValue = ref[0], setSliderValue = ref[1];
    var ref1 = _slicedToArray(useState(showValue), 2), showTooltip = ref1[0], setShowTooltip = ref1[1];
    if (variant === "range") {
        var _sliderValue = _slicedToArray(sliderValue, 2), minValue = _sliderValue[0], maxValue = _sliderValue[1];
        return /*#__PURE__*/ React.createElement(RangeSlider, {
            colorScheme: colorScheme,
            "aria-label": [
                "min",
                "max"
            ],
            defaultValue: defaultValue,
            min: min,
            max: max,
            step: step,
            size: size,
            sx: styles,
            onChange: function(v) {
                if (onChange) onChange(v);
                setSliderValue(v);
            },
            onMouseEnter: function() {
                return setShowTooltip(true);
            },
            onMouseLeave: function() {
                return setShowTooltip(false);
            }
        }, choices && choices.map(function(c, i) {
            return /*#__PURE__*/ React.createElement(SliderMark, {
                value: i * 10,
                key: i,
                mt: "1",
                ml: "-1.5",
                fontSize: "xs"
            }, c);
        }), /*#__PURE__*/ React.createElement(RangeSliderTrack, {
            height: "8px",
            rounded: "lg"
        }, /*#__PURE__*/ React.createElement(RangeSliderFilledTrack, null)), showValue ? /*#__PURE__*/ React.createElement(Tooltip, {
            hasArrow: true,
            bg: "black",
            color: "white",
            placement: "top",
            isOpen: showTooltip,
            label: "".concat(minValue, "%")
        }, /*#__PURE__*/ React.createElement(RangeSliderThumb, {
            boxSize: 6,
            borderColor: "white",
            borderWidth: "medium",
            bgColor: "".concat(colorScheme, ".500"),
            index: 0
        })) : /*#__PURE__*/ React.createElement(RangeSliderThumb, {
            boxSize: 6,
            borderColor: "white",
            borderWidth: "medium",
            bgColor: "".concat(colorScheme, ".500"),
            index: 0
        }), /*#__PURE__*/ React.createElement(Tooltip, {
            hasArrow: true,
            bg: "black",
            color: "white",
            placement: "top",
            isOpen: showTooltip,
            label: "".concat(maxValue, "%")
        }, /*#__PURE__*/ React.createElement(RangeSliderThumb, {
            boxSize: 6,
            borderColor: "white",
            borderWidth: "medium",
            bgColor: "".concat(colorScheme, ".500"),
            index: 1
        })));
    }
    return /*#__PURE__*/ React.createElement(Slider$1, {
        size: size,
        min: min,
        max: max,
        step: step,
        sx: styles,
        "aria-label": "slider",
        colorScheme: colorScheme,
        defaultValue: defaultValue,
        onChange: function(v) {
            if (onChange) onChange(v);
            setSliderValue(v);
        },
        onMouseEnter: function() {
            return setShowTooltip(true);
        },
        onMouseLeave: function() {
            return setShowTooltip(false);
        }
    }, choices && choices.map(function(c, i) {
        return /*#__PURE__*/ React.createElement(SliderMark, {
            value: i * 10,
            key: i,
            mt: "1",
            ml: "-1.5",
            fontSize: "xs"
        }, c);
    }), /*#__PURE__*/ React.createElement(SliderTrack, {
        height: "8px",
        rounded: "lg"
    }, /*#__PURE__*/ React.createElement(SliderFilledTrack, null)), showValue ? /*#__PURE__*/ React.createElement(Tooltip, {
        hasArrow: true,
        bg: "black",
        color: "white",
        placement: "top",
        isOpen: showTooltip,
        label: "".concat(sliderValue, "%")
    }, /*#__PURE__*/ React.createElement(SliderThumb, {
        boxSize: 6,
        borderColor: "white",
        borderWidth: "medium",
        bgColor: "".concat(colorScheme, ".500")
    })) : /*#__PURE__*/ React.createElement(SliderThumb, {
        boxSize: 6,
        borderColor: "white",
        borderWidth: "medium",
        bgColor: "".concat(colorScheme, ".500")
    }));
};

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var anotherComponentsConfig = _objectSpread({}, SnackbarConfig, BannerConfig, DialogConfig, SteperConfig, TabsConfig, PaginationConfig, DropdownConfig, NavMenuConfig, ParagraphConfig, BottomSheetConfig, ProgressBarConfig, NavbarConfig, AppbarConfig, ProgressBarConfig, AppbarConfig, SliderConfig);

export { Appbar, Banner, BottomSheet, Dialog, Dropdown, DropdownItem, Nav, NavMenu, NavMenuItem, Navbar, Pagination, Paragraph, ProgressBar, Slider, Snackbar, Step, Steper, Tab, Tabs, anotherComponentsConfig };
